import styled from "styled-components"
import { device } from "breakpoints"
import { StandardTeaser } from "../TeaserCarousel/style"
import { Title, InnerLink, Excerpt, InfoWrapper } from "components/Teaser/style"
import { MainColumn } from "components/MainColumn"
import { getSolidColor } from "helpers/getSolidColor"
import { getGradient } from "helpers/getGradient"
import { getGradientText } from "helpers/getGradientText"

import { FlexGrid } from "components/FlexGrid"

export const SearchResultsContainer = styled.div`
  overflow: hidden;
  @media ${device.desktop} {
    margin-bottom: ${props => props.extraPadding && "35px"};
  }
`

export const Message = styled(MainColumn)`
  padding-bottom: 30px;
  max-width: 700px;

  @media ${device.desktop} {
    padding-bottom: 80px;
  }


  p {
    font-size: 20px;
    margin-bottom: 15px;
    display: block !important;
    line-height: 27px;
    ${props => getGradientText(props.theme.site)};
    text-align: center;

    @media ${device.desktop} {
      font-size: 28px;
      margin-bottom: 20px;
      line-height: 150%;
    }
  }
`
export const SearchGrid = styled(FlexGrid)`
  transform: translateY(1px);
  overflow: hidden;
`

export const SearchTeaser = styled(StandardTeaser)`
  border-bottom: 1px solid #d2d4e0;
  padding-bottom: 30px;
  width: 100%;

  :hover {
    ${Title} {
      color: ${props => getSolidColor(props.site)};
    }
  }
  @media ${device.tablet} {
    border-bottom: none;
  }

  @media ${device.desktop} {
    padding-bottom: 60px;
  }

  ${InfoWrapper} {
    padding-right: 0;
  }
  ${Title} {
    text-transform: none;
    font-size: 18px;
    font-weight: 600;
    @media ${device.tablet} {
      font-size: 22px;
    }
    @media ${device.desktop} {
      font-size: 28px;
    }
  }

  ${Excerpt} {
    margin-bottom: 16px;
  }

  ${InnerLink}, ${Excerpt} {
    font-size: 16px;

    @media ${device.desktop} {
      font-size: 18px;
    }
  }

  ${InnerLink} {
    span:before {
      background-image: ${props => getGradient(props.site)};
    }
  }

  :after {
    content: "";
    height: 1px;
    left: 0;
    bottom: 0;
    width: 100vw;
    background: #d2d4e0;
    position: absolute;
    display: none;

    @media ${device.tablet} {
      display: block;
    }
  }

  em {
    font-style: normal;
    background: #fff9de;
  }
`

export const Tag = styled.span`
  border-radius: 2px;
  height: 24px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  color: white;
  text-transform: uppercase;
  font-size: 12px;
  order: -2;
  margin-bottom: 20px;
  letter-spacing: 0.86px;
  background-image: ${props => getGradient(props.site)};
  font-weight: 700;
`
